import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import * as React from 'react';

const PortalWhatsNew: React.FC<SvgIconProps> = props => {
	return (
		<SvgIcon {...props}>
			<path fill="none" d="M0 0h24v24H0z" />
			<path d="M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z" />
		</SvgIcon>
	);
};

export default PortalWhatsNew;



// WEBPACK FOOTER //
// ./src/icons/PortalWhatsNew.tsx